import { useState, useCallback, useEffect } from 'react';

interface SpinnerState {
  isLoading: boolean;
  message?: string;
}

let globalSpinnerState: SpinnerState = { isLoading: false };
let listeners: Array<(state: SpinnerState) => void> = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener(globalSpinnerState));
};

export const useGlobalSpinner = () => {
  const [state, setState] = useState<SpinnerState>(globalSpinnerState);

  // Subscribe to global state changes
  useEffect(() => {
    const listener = (newState: SpinnerState) => {
      setState(newState);
    };
    
    listeners.push(listener);
    
    return () => {
      listeners = listeners.filter(l => l !== listener);
    };
  }, []);

  const showSpinner = useCallback((message?: string) => {
    globalSpinnerState = { isLoading: true, message };
    notifyListeners();
  }, []);

  const hideSpinner = useCallback(() => {
    globalSpinnerState = { isLoading: false };
    notifyListeners();
  }, []);

  return {
    isLoading: state.isLoading,
    message: state.message,
    showSpinner,
    hideSpinner
  };
};

// Global functions that can be used anywhere
export const showGlobalSpinner = (message?: string) => {
  globalSpinnerState = { isLoading: true, message };
  notifyListeners();
};

export const hideGlobalSpinner = () => {
  globalSpinnerState = { isLoading: false };
  notifyListeners();
};